import React, { ReactNode } from "react";
import styled from "styled-components";
import { LifeAtBodyPrimary } from "@common/LifeAtText/LifeAtText";
import { FontSize } from "@themes/Fonts";
import { ScrollbarStyles } from "@themes/ScrollbarStyles";
import { projectList$, selectedProjectId$ } from "../../../../projects/ProjectGlobals";
import CreateProjectButton from "../../../../projects/components/CreateProjectButton";
import ProjectDetails from "../../../../projects/components/ProjectDetails";
import ProjectItem from "../../../../projects/components/ProjectItem";

const ProjectListViewContainer = styled.div<{ isVisible: boolean }>`
    display: ${(props) => (props.isVisible ? "flex" : "none")};
    background: ${(props) => props.theme.backgroundSecondary};
    height: 100%;
    width: 100%;
`;

const ProjectListViewContent = styled.div`
    display: flex;
    flex-direction: column;
    padding: 20px;
    gap: 15px;
`;

const ProjectsList = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    overflow-y: auto;
    ${ScrollbarStyles};
    ::-webkit-scrollbar-thumb {
        border: 3px ${(props) => props.theme.backgroundSecondary} solid;
    }
`;

const ProjectsHeader = styled(LifeAtBodyPrimary)`
    font-size: ${FontSize.large};
`;

const StyledCreateProjectButton = styled(CreateProjectButton)`
    width: fit-content;
`;

const PROJECTS_LIST_HEADER = "Projects";

interface ProjectsListViewProps {
    readonly isVisible: boolean;
}

export default function ProjectsListView(props: ProjectsListViewProps) {
    let contentToShow: ReactNode;

    if (selectedProjectId$.value) {
        contentToShow = (
            <ProjectDetails
                projectId={selectedProjectId$.value}
                project={projectList$.value[selectedProjectId$.value]}
                onClose={() => (selectedProjectId$.value = undefined)}
            />
        );
    } else {
        contentToShow = (
            <ProjectListViewContent>
                <ProjectsHeader>{PROJECTS_LIST_HEADER}</ProjectsHeader>
                <StyledCreateProjectButton amplitudeSource={"project-list"} />
                <ProjectsList>
                    {Object.entries(projectList$.value).map(([projectId, project]) => (
                        <ProjectItem
                            key={projectId}
                            project={project}
                            projectId={projectId}
                            setSelectedProjectId={(projectId: string) => (selectedProjectId$.value = projectId)}
                        />
                    ))}
                </ProjectsList>
            </ProjectListViewContent>
        );
    }

    return <ProjectListViewContainer isVisible={props.isVisible}>{contentToShow}</ProjectListViewContainer>;
}
